import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import tDesign from 'tdesign-vue-next'
// 自定义主题
import './theme.css'
import './rest.scss'
import './assets/styles/style.scss'
// 路由守卫
import './permission'

import PageHeader from '@components/PageHeader/index.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

createApp(App).use(router).use(pinia).use(tDesign).component('PageHeader', PageHeader).mount('#app')


// 检查版本信息
import axios from 'axios'
import { DialogPlugin } from 'tdesign-vue-next'
declare const __APP_VERSION__: string | number

// 添加标志位，避免重复弹窗
let hasShownUpdateDialog = false

const versionCheck = async () => {
    if (import.meta.env.MODE !== 'production') return

    // 如果已经显示过弹窗，直接返回
    if (hasShownUpdateDialog) return

    if (import.meta.url.includes('local') || import.meta.url.includes('192.168')) return
    const response = await axios.get('version.json')
    // console.log('__APP_VERSION__', __APP_VERSION__)
    // console.log('response.data.version', response.data.version)
    if (__APP_VERSION__ !== response.data.version) {
        // 设置标志位，避免重复弹窗
        hasShownUpdateDialog = true

        DialogPlugin.confirm({
            header: '系统更新提示',
            body: '发现新版本，请刷新页面。（windows系统请按ctrl+F5，mac系统请按command+shift+R）',
            closeOnOverlayClick: false,
            closeOnEscKeydown: false,
            cancelBtn: null,
            confirmBtn: null,
            closeBtn: false,
        })
    }
}

// 仅生产环境检测版本更新，测试环境不检测
if (import.meta.env.MODE === 'production') {
    setInterval(() => {
        versionCheck()
    }, 1000 * 60 * 60)
}
